import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ITicket, ITicketListingViewModel, ITicketParameter } from '../../models/ticket';
import { AUTHORIZATION_FUNCTIONALITIES, AUTHORIZATION_MODULE_NAMESPACE } from '../../store/authorization';
import { TICKET_ACTION, TICKET_GET_CHARACTER_PROBLEMS, TICKET_GET_TICKETS, TICKET_GET_TICKET_PRIORITY_LEVEL, TICKET_GET_TICKET_PROBLEM_TYPE, TICKET_GET_TICKET_SUBSTATUS, TICKET_INIT, TICKET_MODULE_NAMESPACE, TICKET_RECORD, TICKET_RESET, TICKET_UPDATE } from '../../store/ticket';
import { isNullOrUndefined } from 'util';
import { eventBus } from '../../main';
import { CrudStatus } from '../../common/enums';
import { EQUIPMENT_RECORD, EQUIPMENT_SET_BY_FIELD, EQUIPMENT_UPDATE, MAINTENANCE_INIT_FIELDS, MAINTENANCE_MODULE_NAMESPACE, MAINTENANCE_PATCH_UPDATE, MAINTENANCE_POST_CREATE } from '../../store/maintenance';
import { IEquipment } from '../../models/equipment/equipment.model';
import { TranslateResult } from 'vue-i18n';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_SET_SEARCH_PARAMS } from '../../store/service-book';
import { IServiceBookSearchParams } from '../../store/service-book/service-book-state.store';
import { ServiceBookService } from '../../services/serviceBook.service';


const TicketStore = namespace(TICKET_MODULE_NAMESPACE);
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)
const MaintenanceStore = namespace(MAINTENANCE_MODULE_NAMESPACE);
const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)

@Component({
  components:{
    'ticket-modal-vertical': async () => import('@/containers/ticket/components/ticket-modal-vertical/TicketModalVertical.vue'),
    'equipment-modal-vertical': async () => import('@/containers/block/components/block-equipment-modal-vertical/BlockEquipmentModalVertical.vue'),
    'maintenance-modal-vertical': async () => import('@/containers/block/components/block-maintenance-modal-vertical/BlockMaintenanceModalVertical.vue'),
    'modal-buy-service-book': async () => import('@/containers/home/components/modal-buy-servicebook/ModalBuyServiceBook.vue'),
  }
})
class ServiceBookContainer extends Vue {


  // === tickets
  @TicketStore.Action(TICKET_UPDATE)
  storeUpdateTicket: (payload?: any) => any | Promise<any>
  @TicketStore.Action(TICKET_RECORD)
  storeRecordTicket: (payload: { attachments?: any[], keepAlive?: boolean }) => any | Promise<any>
  @TicketStore.Action(TICKET_ACTION)
  storeTicketActionRequest: ({ actionName, ticketId, textKey, data }) => Promise<any>;
  @TicketStore.Getter currentTicket: ITicketListingViewModel;
  @TicketStore.Mutation(TICKET_INIT)
  storeSetCurrentTicket: (payload?: ITicket) => void;
  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>;
  @TicketStore.Action(TICKET_RESET)
  storeResetTicket: () => void;
  @TicketStore.Action(TICKET_GET_TICKETS)
  storeGetTickets: (payload: { param: ITicketParameter, merge?: boolean }) => any | Promise<any>
  @TicketStore.Action(TICKET_GET_CHARACTER_PROBLEMS)
  storeGetCharacterProblems: () => void;
  @TicketStore.Action(TICKET_GET_TICKET_PRIORITY_LEVEL)
  storeGetTicketPriorityLevel: () => void;
  @TicketStore.Action(TICKET_GET_TICKET_SUBSTATUS)
  storeGetTicketSubstatus: () => void;
  @TicketStore.Action(TICKET_GET_TICKET_PROBLEM_TYPE)
  storeGetTicketProblemType: () => void;

  // == equipments
  @MaintenanceStore.Getter equipmentCrudActionStatus: CrudStatus
  @Watch('equipmentCrudActionStatus')
  onEquipmentCrudActionStatusChange(newVal: CrudStatus) {
    if(newVal === CrudStatus.Update) this.handleAddEquipment()
  }
  @MaintenanceStore.Mutation(EQUIPMENT_SET_BY_FIELD)
  storeAssignValueForEquipment: (payload: IEquipment) => void;
  @MaintenanceStore.Getter currentEquipment: any;
  @MaintenanceStore.Action(EQUIPMENT_UPDATE)
  storeUpdateEquipment: () => Promise<any>
  @MaintenanceStore.Action(EQUIPMENT_RECORD)
  storeRecordEquipment: () => Promise<any>

  // === maintenance
  @MaintenanceStore.Action(MAINTENANCE_POST_CREATE)
  storeCreateMaintenance: () => Promise<any>
  @MaintenanceStore.Mutation(MAINTENANCE_INIT_FIELDS)
  storeMaintenanceInitFields: () => void;
  @MaintenanceStore.Action(MAINTENANCE_PATCH_UPDATE)
  storeUpdateMaintenance: (id:string) => Promise<any>

  // === serviceBook
  @ServiceBookStore.Mutation(SERVICEBOOK_SET_SEARCH_PARAMS)
  storeServiceBookSearchParameter: (parameter: IServiceBookSearchParams) => void;

  @ServiceBookStore.Getter searchParams:IServiceBookSearchParams
  @ServiceBookStore.Getter isLoading: boolean;



  // == shared
  dtIsRecording: boolean | null;
  dtErrorModalVisible: boolean;
  dtError: any;
  // === tickets
  dtTicketModalVisible: boolean;
  dtCreateAnother: boolean;
  dtUpdateTicket: boolean
  dtAttachments: any[];
  dtLatestTicketCreated: { ticketId: number, channelId: number } | null;
  dtMandateRequestPayload: { attachments: any[], fk_actor_entity: number[], service_order: string };
  // === equipment
  equipmentIcon:string
  isVehicle:boolean
  dtEquipmentModalVisible: boolean;
  // === maintenance
  dtMaintenanceModalVisible: boolean;
  isUpdateMaintenance:boolean
  maintenanceData:any
  isScheludeEquipmentMaintenance:boolean
  // === buy servicebook modal
  buyServiceBookModal:boolean
  serviceBookProduct:any[]
  ServiceBookService:ServiceBookService



  constructor(){
    super()
    // == shared
    this.dtIsRecording = null;
    this.dtErrorModalVisible = false;
    this.dtError = null;
    // === tickets
    this.dtTicketModalVisible = false;
    this.dtCreateAnother = false;
    this.dtUpdateTicket= false
    this.dtAttachments = [];
    this.dtLatestTicketCreated = null;
    this.dtMandateRequestPayload = this.initMandate();
    // === equipment
    this.equipmentIcon = 'handyman'
    this.isVehicle = false
    this.dtEquipmentModalVisible= false
    // === maintenance
    this.dtMaintenanceModalVisible= false
    this.isUpdateMaintenance = false
    this.maintenanceData = {}
    this.isScheludeEquipmentMaintenance = false
    // === buy servicebook modal
    this.buyServiceBookModal = false
    this.serviceBookProduct = []
    this.ServiceBookService = new ServiceBookService()


  }


  beforeMount(){
    // === get servicebook product
    this.ServiceBookService.getServiceBookProduct().then((response:any[])=>{
      console.log(response)
      this.serviceBookProduct = response
    })

    eventBus.$on('OPEN_MAINTENANCE_MODAL',(data)=>{
      console.log('OPEN_MAINTENANCE_MODAL', {data})
      this.maintenanceData = data.maintenance
      this.isUpdateMaintenance = true
      this.$nextTick(()=>{
        this.handleAddmaintenance()
      })
    })

    eventBus.$on('SCHEDULE_MAINTENANCE_EQUIPMENT',(data)=>{
      console.log('SCHEDULE_MAINTENANCE_EQUIPMENT',{data})
      this.maintenanceData = {
        FKEquipmentCategory:data.categoryId,
        FKEquipmentSubCategory:data.subCategoryId,
        FKEquipment:data.equipmentId
      }
      this.isScheludeEquipmentMaintenance = true
      this.$nextTick(()=>{
        this.handleAddmaintenance()
      })
    })
  }

  beforeDestroy(){
    eventBus.$off('OPEN_MAINTENANCE_MODAL')
    eventBus.$off('SCHEDULE_MAINTENANCE_EQUIPMENT')
  }



  mounted() {

    this.storeGetCharacterProblems();

    if (this.requestedMandate) {
      setTimeout(() => {
        this.dtTicketModalVisible = true;
        if (this.$route.query.contractors && this.$route.query.contractors.length > 0) {
          this.dtMandateRequestPayload.fk_actor_entity = this.$route.query.contractors.split(',').map(id => parseInt(id))
        }
      }, 500);
    }
    this.storeGetTicketPriorityLevel();
    this.storeGetTicketSubstatus();
    this.storeGetTicketProblemType()
  }

  get lblSetting() {
    return {
      ...require('@/locales/service-book').default,
      ...require('@/locales/ticket').default,
      ...require('@/locales/block').default,
      ...require('@/locales/apartment').default,
      ...require('@/locales/profile').default,
      ...require('@/locales/equipment').default,
      ...require('@/locales/button').default,
      ...require('@/locales/document').default
    }
  }

  get coKeyword(): string {
    /* if (this.$route.path.indexOf('apartment') > -1) {
      return this.apartmentParameter.key;
    } else if (this.$route.path.endsWith('equipment')) {
      return this.blockEquipmentParameter.q
    } else if(this.$route.name === 'block_vehicle_fleet'){
      return this.blockVehicleFleetParameter.q
    }
    else if (this.$route.path.endsWith('block')) {
      return this.blockParameter.key;
    } else if (this.$route.path.indexOf('contact') > -1 ) {
      return this.blockEntityParameter.q;
    } else if (this.$route.path.indexOf('document') > -1) {
      return this.documentParameter.key
    } else if (this.$route.path.indexOf('maintenance') > -1){
      return this.maintenanceSearchParams.q
    } */
    if(this.$route.path === `/service-book`)
    {
      return this.searchParams.key
    }
    return null
  }

  set coKeyword(value: string) {
    // TODO TO CHANGE
    /* if (this.$route.path.indexOf('apartment') > -1) {
      this.storeSetApartmentParamter({ key: value });
    } else if (this.$route.path.endsWith('equipment')) {
      this.storeSetBlockEquipmentParameter({ q: value });
    } else if (this.$route.name === 'block_vehicle_fleet') {
      this.storeSetBlockVehicleFleetParameter({ q: value });
    } else if (this.$route.path.endsWith('block')) {
      this.storeSetBlockParamter({ key: value });
    } else if (this.$route.path.indexOf('contact') > -1 ) {
      this.storeSetEntityKeyword({ q: value })
    } else if (this.$route.path.indexOf('document') > -1){
      this.storeSetDocumentParameter({key: value})
    } else if (this.$route.path.indexOf('maintenance') > -1){
      this.storeMaintenancesSearchParams({
        ...this.maintenanceSearchParams,
        $limit:10,
        $skip:0,
        q:value
      })
      eventBus.$emit('SEARCH_MAINTENANCE_BY_KEYWORD',value)
    } */
    if(this.$route.path === `/service-book` && !this.searchParams.free)
    {
      this.storeServiceBookSearchParameter({key:value, number:null})
      if(value.length > 2 || value.length === 0)
      {
        setTimeout(() => {
          if(!this.isLoading)
          {
            eventBus.$emit('RELOAD_SERVICEBOOK')
          }
        }, 1000);
      }
    } else if(this.$route.path === `/service-book` && this.searchParams.free) {
      this.storeServiceBookSearchParameter({number:value, key:null})
      setTimeout(() => {
        if(!this.isLoading)
        {
          eventBus.$emit('RELOAD_SERVICEBOOK')
        }
      }, 1000);
    }
  }

  get searchVisible(): boolean {
    /* if (this.$route.path.endsWith('apartment')) {
      return true
    } else if (this.$route.path.endsWith('equipment')) {
      return true
    } else if (this.$route.path.endsWith('block')) {
      return true
    } else if (this.$route.path.indexOf('contact') > -1 ) {
      return true
    } else if(this.$route.path.indexOf('document') > -1 ) {
      return true
    } else if(this.$route.path.indexOf('maintenance') > -1 && this.$route.path, this.$route.path.split('/').length==4) {
      return true
    } */
    if(this.$route.path === `/service-book`)
    {
      return true
    }
    return false
  }

  get hideAddButton () {
    switch (this.$route.path) {
      case '/service-book':
      //case `/service-book/${this.$route.params.id}`:
        return false
      case `/service-book/${this.$route.params.id}/tickets`:
        return !this.$route.meta['create_ticket']
      case `/service-book/${this.$route.params.id}/documents`:
        return !this.$route.meta['create_document']
      case `/service-book/${this.$route.params.id}/equipments`:
        return !this.$route.meta['manage_equipment']
      case `/service-book/${this.$route.params.id}/maintenances`:
        return !this.$route.meta['add_maintenance']
      default:
        return true
    }
  }

  get AddButtonToolTip()
  {
    switch (this.$route.path) {
      case '/service-book':
        return 'Acheter des carnets d\'entretien'
      case `/service-book/${this.$route.params.id}/tickets`:
        return this.$t(this.lblSetting.ticketCreate)
      case `/service-book/${this.$route.params.id}/documents`:
        return this.$t(this.lblSetting.documentAdd)
      case `/service-book/${this.$route.params.id}/equipments`:
        return this.$t(this.lblSetting.equipmentModal.create)
      case `/service-book/${this.$route.params.id}/maintenances`:
        return this.$t(this.lblSetting.maintenanceModal.create)
      default:
        return true
    }
  }

  handleOpenModal() {
    switch (this.$route.path) {
      case '/service-book':
      //case `/service-book/${this.$route.params.id}`:
        return this.handleOpenModalBuyServiceBook()
      case `/service-book/${this.$route.params.id}/tickets`:
        return this.handleAddTicket()
      case `/service-book/${this.$route.params.id}/documents`:
        return eventBus.$emit('BLOCK_CREATE_DOCUMENT')
      case `/service-book/${this.$route.params.id}/equipments`:
        return this.handleAddEquipment()
      case `/service-book/${this.$route.params.id}/maintenances`:
        return this.handleAddmaintenance()
      default:
        return () => {}
    }
  }

  handleOpenModalBuyServiceBook()
  {
    this.buyServiceBookModal = true
  }


  handleAddmaintenance()
  {
    this.dtMaintenanceModalVisible = true;
  }





  handleSaveMaintenance()
  {
    this.dtIsRecording= true
    eventBus.$emit('SET_ISLOADING_MODAL_MAINTENANCE',true)
    if(!this.isUpdateMaintenance)
    {
      console.log('save maintenance')
      this.storeCreateMaintenance().then(createdMaintenance=>{
        eventBus.$emit('RELOAD_BLOCK_DASHBORD',this.$route.params.id)
        console.log({createdMaintenance})
        this.dtMaintenanceModalVisible = false
        this.storeMaintenanceInitFields()
        this.$router.push(
          {
            path:`/block/${this.$route.params.id}/maintenance/${createdMaintenance.id}`,
            params: {
              id: this.$route.params.id,
              cid: createdMaintenance.id
            }
          },()=>{
            // onComplete
            eventBus.$emit('RELOAD_MAINTENANCE_AFTER_UPDATE', createdMaintenance)
          }
        )
      }).catch(error=>{
        console.log({error})
      }).finally(()=>{
        this.dtIsRecording= false
      })
    }
    else
    {
      console.log('update maintenance', this.maintenanceData)
      this.storeUpdateMaintenance(this.maintenanceData.id).then(updatedMaintenance=>{
        console.log({updatedMaintenance})
        this.maintenanceData = null
        this.isUpdateMaintenance = false
        this.dtMaintenanceModalVisible = false
        this.storeMaintenanceInitFields()
        /* this.$router.push(
          {
            path:`/block/${this.$route.params.id}/maintenance/${updatedMaintenance.id}`,
            params: {
              id: this.$route.params.id,
              cid: updatedMaintenance.id
            }
          }
        ) */
        eventBus.$emit('RELOAD_MAINTENANCE_AFTER_UPDATE', updatedMaintenance)
      }).catch(error=>{
        console.log({error})
      }).finally(()=>{
        this.dtIsRecording= false
      })
    }
  }



  handleAddEquipment() {
    if(this.$route.name === 'block_vehicle_fleet' || this.$route.name === 'block_vehicle_details')
    {
      this.equipmentIcon = 'drive_eta'
      this.isVehicle = true
    }else{
      this.equipmentIcon = 'handyman'
      this.isVehicle = false
    }
    this.dtEquipmentModalVisible = true;
  }


  handleSaveEquipment(changeDisable: boolean = false) {
    this.dtIsRecording= true
    if (this.isUpdateAction) {
      if (changeDisable) {
        this.storeAssignValueForEquipment({disable: !this.currentEquipment.disable})
      }
      this.storeUpdateEquipment()
        .then(response => {
          this.dtEquipmentModalVisible = false
        })
        .catch(err=>{
          this.dtError= err
          this.dtErrorModalVisible= true
        })
        .finally(()=>{
          this.dtIsRecording= false
        })
    } else {
      this.storeRecordEquipment()
        .then(response => {
          eventBus.$emit('RELOAD_BLOCK_DASHBORD',this.$route.params.id)
          this.dtEquipmentModalVisible = false
          /* this.$router.push({
            path: `/block/${this.$route.params.id}/equipment/${response.id}`,
            params: {
              id: this.$route.params.id,
              cid: response.id
            }
          }) */
          //let routeToGo = response.fk_character_problem_lvl1 === 238 ? 'block_vehicle_details' : 'block_equipment_details'
          //this.$router.push({name:routeToGo,params:{id: this.$route.params.id, cid: response.id}})
          this.$router.push(`/service-book/${this.$route.params.id}/equipments/${response.id}`)
        })
        .catch(err=>{
          this.dtError= err
          this.dtErrorModalVisible= true
        })
        .finally(()=>{
          this.dtIsRecording= false
        })
    }
  }

  get isUpdateAction(): boolean {
    return this.equipmentCrudActionStatus === CrudStatus.Update
  }

  get requestedMandate() {
    return this.$route.query && this.$route.query.modal === 'mandate'
  }

  get buttonTextTicket() {
    return this.requestedMandate
      ? this.$t(this.lblSetting.btnRecord) :
      this.dtUpdateTicket ?
      this.$t(this.lblSetting.ticketSave)
      : this.$t(this.lblSetting.ticketCreateNew)
  }

  get buttonText() : TranslateResult {
    return this.isUpdateAction ? this.$t(this.lblSetting.btnUpdate) : this.$t(this.lblSetting.blockSave)
  }

  get maintenanceModalTitle() : TranslateResult {
    return this.isUpdateMaintenance ? this.$t(this.lblSetting.maintenanceModal.update) : this.$t(this.lblSetting.maintenanceModal.create)
  }



  get maintenanceMaxWidth(): string {
    return `${document.body.clientWidth * 0.9}px`
  }



  get modalTitleTicket() {
    return this.requestedMandate
      ? this.$t(this.lblSetting.ticketChatActionsMandateASpecker)
      :
      this.dtUpdateTicket ? this.$t(this.lblSetting.ticketEdit)
      : this.$t(this.lblSetting.ticketCreate)
  }

  get equipmentModalTitle() : TranslateResult {
    return this.isUpdateAction ? this.$t(this.lblSetting.equipmentModal.update) : this.$t(this.lblSetting.equipmentModal.create)
    /* switch(this.$route.name)
    {
      case 'block_equipment':
      case 'block_equipment_details':
        return this.isUpdateAction ? this.$t(this.lblSetting.equipmentModal.update) : this.$t(this.lblSetting.equipmentModal.create)
      case 'block_vehicle_fleet':
      case 'block_vehicle_details':
        return this.isUpdateAction ? this.$t(this.lblSetting.vehicleModal.update) : this.$t(this.lblSetting.vehicleModal.create)
    } */
  }

  get apartmentMaxWidth(): string {
    return `${document.body.clientWidth * 0.9}px`
  }

  get maxWidth(): string {
    return this.requestedMandate ? '80%' : `${document.body.clientWidth * 0.9}px`;
  }



  handleSave(event) {
    this.dtIsRecording = true;

    if(this.dtUpdateTicket){
      this.handleUpdateTicket(null,true)
    }
    else if (this.requestedMandate) {
      this.handleSaveMandate();
    } else {
      this.handleSaveticket(event);
    }
  }

  handleUpdateTicket(event: MouseEvent, save:boolean= false){
    if(save){
      return this.storeUpdateTicket()
          .then( (updatedTicket: ITicket )=>{
          })
          .catch(err=>{
            this.dtErrorModalVisible= true
            this.dtError= err
          })
          .finally(()=>{
            this.dtIsRecording= false
            this.dtUpdateTicket= false
            this.dtTicketModalVisible= false
          })
    }

    this.dtUpdateTicket= true
    this.handleDuplicateTicket(true)
    //this.handleAddTicket('ticket_update')
  }

  handleSaveticket(event) {
    this.storeRecordTicket({ attachments: this.dtAttachments, keepAlive: this.dtCreateAnother })
      .then((createdTicket: ITicket) => {
        this.dtIsRecording = false;
        this.dtAttachments = [];
        if (this.dtCreateAnother === false) {
          this.dtTicketModalVisible = false;
          this.handleRedirectTo(createdTicket.id, createdTicket.channel_public);
        } else {
          this.dtLatestTicketCreated = { ticketId: createdTicket.id, channelId: createdTicket.channel_public };
        }
      })
      .catch(error => {
        this.dtIsRecording = false;
        this.dtErrorModalVisible = true;
        this.dtError = error;
        throw error;
      })
  }
  handleSaveMandate() {
    this.storeTicketActionRequest({
      ticketId: this.$route.params.id,
      actionName: 'actionRequestMandateOrQuote',
      data: this.dtMandateRequestPayload,
      textKey: 'service_order'
    })
      .then(response => {
        this.dtIsRecording = false;
        this.dtTicketModalVisible = false;

        this.$router.replace('/ticket');
        this.dtMandateRequestPayload = this.initMandate();
      })
      .catch(error => {
        this.dtIsRecording = false;
        this.dtErrorModalVisible = true;
        this.dtError = error;
        throw error;
      })
  }

  handleDuplicateTicket(update:boolean= false) {
    let availabilityMileage = this.currentTicket.ticket_availability_mileage ? true: false
    this.storeSetCurrentTicket(Object.assign({},
    {
      ... update && { id: this.currentTicket.id },
      origin_demand: this.currentTicket.origin_demand,
      //creator: this.currentTicket.creator[0].id,
      declarant: this.currentTicket.declarant.length ? this.currentTicket.declarant[0].id : null,
      ... this.currentTicket.independents_contractors_mandate && { mandates: this.currentTicket.independents_contractors_mandate.map(x => x.id) },
      ... this.currentTicket.independents_contractors_quote && { quotes: this.currentTicket.independents_contractors_quote.map(x => x.id) },
      pb_type: this.currentTicket.pb_type,
      fk_ticket_block: this.currentTicket.fk_ticket_block,
      fk_ticket_character_problem: this.currentTicket.fk_ticket_character_problem,
      fk_character_problem_level_2: this.currentTicket.fk_character_problem_level_2,
      fk_ticket_priority: this.currentTicket.ticket_priority.id,
      fk_ticket_substatus: this.currentTicket.fk_ticket_substatus,
      equipments: this.currentTicket.equipments.map(x => x.id),
      apartment_zone: this.currentTicket.apartment_zone.map(x => x.id),
      description: this.currentTicket.description,
      mileage: availabilityMileage ? this.currentTicket.ticket_availability_mileage.mileage : null,
      availability: availabilityMileage ? this.currentTicket.ticket_availability_mileage.availability: null,
      subject: update ? this.currentTicket.subject : this.$t(this.lblSetting.ticketCopyOf) + this.currentTicket.subject,
      ... this.currentTicket.apartments && { apartments: this.currentTicket.apartments.map(x => x.id) },
      participants: this.currentTicket.managers.concat(this.currentTicket.tenants).concat(this.currentTicket.owners),
      ... this.currentTicket.managers_assigned && { managers_assigned: this.currentTicket.managers_assigned.map(x => x.id)},
    }))

    //if(update) return this.handleAddTicket('ticket_update')
    this.handleAddTicket()
  }

  handleRedirectTo(ticketId: number, channelId: number) {
    setTimeout(() => this.$router.push({
      path: `/ticket/${ticketId}/channel/${channelId}`, params: {
        id: ticketId.toString(), cid: channelId.toString()
      }
    }), 100);
  }

  initMandate() {
    return {
      attachments: [],
      fk_actor_entity: [],
      service_order: ''
    };
  }

  handleAddTicket(functionality?:string) {
    this.storeGetFunctionalities('ticket_create')
      .then(response => {
        if (this.$route.meta) {
          Object.keys(response).forEach(key => this.$route.meta[key] = true);
        }

        this.storeGetFunctionalities('ticket_external_apartment')
        .then(last_response=>{
          if(this.$route.meta){
            Object.keys(last_response).forEach(key => this.$route.meta[key] = true);
          }

          this.dtTicketModalVisible = true;
        })
      })
      .catch(error => console.log(error));
  }

  handleClose(){
    this.dtUpdateTicket= false
  }

  handleBeforeModalClose() {
    setTimeout(() => this.storeResetTicket(), 300);
    if (!isNullOrUndefined(this.dtLatestTicketCreated)) {
      if (!this.$route.path.match('channel')) {
        this.storeGetTickets({ param: { $skip: 0 }, merge: true });
      } else {
        this.handleRedirectTo(this.dtLatestTicketCreated.ticketId, this.dtLatestTicketCreated.channelId);
      }
      this.dtLatestTicketCreated = null;
      /** TODO later */
    }
    if (this.requestedMandate) {
      this.$router.replace('/ticket');
      this.dtMandateRequestPayload = this.initMandate();
    }
  }

  handleRemoveError() {
    this.dtErrorModalVisible = false
    this.dtError = null;
  }
}

export default ServiceBookContainer;



// WEBPACK FOOTER //
// ./src/containers/service-book/index.ts